/**
 * Labstep
 *
 * @module components/UserOrganization/Action/AddBulkUsers
 * @desc Action to add multiple users to organization
 */

import { UserOrganizationActionAddBulkUsersCreateUsers as CreateUsers } from 'labstep-web/components/UserOrganization/Action/AddBulkUsers/CreateUsers';
import { EntityCreateContainer } from 'labstep-web/containers/Entity/Create';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { Button } from 'labstep-web/core/Button';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import { User } from 'labstep-web/models/user.model';
import type React from 'react';
import styles from './styles.module.scss';
import type { UserOrganizationActionAddBulkUsersProps } from './types';

export const UserOrganizationActionAddBulkUsers: React.FC<
  UserOrganizationActionAddBulkUsersProps
> = ({ organization }) => {
  const showWarning =
    organization.max_seats !== null &&
    organization.availableSeats !== null &&
    organization.availableSeats <= 0;

  const warningContent = (
    <span>
      You cannot add more users because you have reached the user
      limit for your plan. Please contact{' '}
      <a href="mailto:sales@labstep.com">sales@labstep.com</a> or your
      account manager to add more.
    </span>
  );
  const warningHeader = (
    <span className={styles.header}>User Limit Reached</span>
  );
  const header = 'Add Users';

  return (
    <ModalDefault
      size="small"
      header={showWarning ? warningHeader : header}
      content={
        showWarning
          ? warningContent
          : ({ toggleModal }) => (
              <EntityCreateContainer
                entityName={User.entityName}
                batch
              >
                {({ create, status }) => (
                  <CreateUsers
                    organization={organization}
                    toggleModal={toggleModal}
                    create={create}
                    status={status}
                  />
                )}
              </EntityCreateContainer>
            )
      }
      viewComponent={({ toggleModal }) => (
        <ActionComponent
          onClick={toggleModal}
          type="button"
          text="Add Users"
        />
      )}
      footer={
        showWarning
          ? ({ toggleModal }) => (
              <Button
                className={styles.closeButton}
                onClick={toggleModal}
              >
                Close
              </Button>
            )
          : null
      }
    />
  );
};
